module.exports = __webpack_public_path__ + "1.4.15-unryo/img/aws.93dc1295.svg";